import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useCheckCountryForSepa = countryCode => {
  return useQuery({
    staleTime: 1000 * 60 * 60,
    enabled: !!countryCode,
    queryKey: [QUERY_KEYS.cash.country_sepa_check, countryCode],
    queryFn: () =>
      cashService.checkCountrySepa(countryCode).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
